(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPersonaDeleteController',SSPersonaDeleteController);

    SSPersonaDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSPersona'];

    function SSPersonaDeleteController($uibModalInstance, entity, SSPersona) {
        var vm = this;

        vm.sSPersona = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSPersona.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
